import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import axios from '@src/service/axios';
import { toast } from 'react-toastify';

// Loader Components
import showLoader from '@components/loader';

export const getRoadType = createAsyncThunk('roadTypeSlice/getRoadType', async () => {
    try {
        let response = await axios.get('/road-type', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getRoadTypeOption = createAsyncThunk('roadTypeSlice/getRoadTypeOption', async () => {
    try {
        showLoader(true);
        let response = await axios.get('/road-type?option=true', {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createRoadType = createAsyncThunk('roadTypeSlice/createRoadType', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.post('/road-type', data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'RoadType created successfully.');
        dispatch(getRoadType());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateRoadType = createAsyncThunk('roadTypeSlice/updateRoadType', async (data, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/road-type/' + data?.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'RoadType updated successfully.');
        dispatch(getRoadType());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const deleteRoadType = createAsyncThunk('roadTypeSlice/deleteRoadType', async (deleteId, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.delete('/road-type/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'RoadType deleted successfully');
        dispatch(getRoadType());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const updateRoadTypeStatus = createAsyncThunk('roadTypeSlice/updateRoadTypeStatus', async (id, { dispatch }) => {
    try {
        showLoader(true);

        let response = await axios.put('/road-type/status/' + id, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
        toast.success(response?.data?.message || 'Status updated successfully.');
        dispatch(getRoadType());
        showLoader(false);
        return Promise.resolve(response.data);
    } catch (err) {
        showLoader(false);
        toast.err(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const roadTypeSlice = createSlice({
    name: 'roadTypeSlice',
    initialState: {
        data: [],
        option: []
    },
    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(getRoadType.fulfilled, (state, action) => {
            state.data = action.payload;
            return;
        });
        builder.addCase(getRoadTypeOption.fulfilled, (state, action) => {
            state.option = action.payload;
            return;
        });
    }
});

export default roadTypeSlice.reducer;
